import { classNames } from '@vkontakte/vkjs';
import { Caption } from '@vkontakte/vkui';
import React from 'react';
import styles from './MessagesListSystemLine.module.css';

interface MessagesListSystemLineProps {
  children?: React.ReactNode;
  separator?: boolean;
  testId?: string;
}

export function MessagesListSystemLine(props: MessagesListSystemLineProps) {
  const { children, separator, testId } = props;

  return (
    <div data-testid={testId} className={classNames(styles.root, separator && styles.root__separator)}>
      <Caption className={styles.content} level="1" weight="3" useAccentWeight>
        {children}
      </Caption>
    </div>
  );
}
